import { render, staticRenderFns } from "./Soja2022TerrasIndigenasParaguai.vue?vue&type=template&id=4c1d399f&lang=pug"
import script from "./Soja2022TerrasIndigenasParaguai.vue?vue&type=script&lang=js"
export * from "./Soja2022TerrasIndigenasParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports